import { render, staticRenderFns } from "./EditAttendanceDialog.vue?vue&type=template&id=0baee8b4"
import script from "./EditAttendanceDialog.vue?vue&type=script&lang=js"
export * from "./EditAttendanceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports